var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, ButtonMode, ButtonVariant } from '../../../Components/Button';
import { AlertEyeIcon, AlertIconRound, DecisionAlertAcceptableIcon, DecisionAlertWarningIcon, ExternalLinkIcon } from '../../../Components/Icons';
import { PrescriptionMonitoringStatus } from '../../../Contracts/MedicationModels';
import { body, dangerVariant, green, primary, warningGlowBorder } from '../../../Styles/Colours';
import styles from './DecisionAlertFloating.module.css';
export function DecisionAlertFloating(props) {
    var rtpmStatus = props.decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail.status;
    var showPrescriptionMonitoringSection = rtpmStatus === PrescriptionMonitoringStatus.Acceptable ||
        rtpmStatus === PrescriptionMonitoringStatus.Warning ||
        rtpmStatus === PrescriptionMonitoringStatus.Alert ||
        rtpmStatus === PrescriptionMonitoringStatus.Error;
    return (React.createElement(React.Fragment, null, showPrescriptionMonitoringSection && (React.createElement(RealTimePrescriptionMonitoring, { showDecisionSupportWizard: props.showDecisionSupportWizard, decisionSupportInformation: props.decisionSupportInformation, rtpmStatus: rtpmStatus }))));
}
function RealTimePrescriptionMonitoring(props) {
    var showViewMoreDetailsSection = props.rtpmStatus === PrescriptionMonitoringStatus.Warning ||
        props.rtpmStatus === PrescriptionMonitoringStatus.Alert ||
        props.rtpmStatus === PrescriptionMonitoringStatus.Error;
    return (React.createElement("div", { className: styles.positioner },
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.rtpmHeader }, "Real Time Prescription Monitoring"),
            React.createElement(RTPMInformation, { decisionSupportInformation: props.decisionSupportInformation }),
            showViewMoreDetailsSection && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.dividerLine }),
                React.createElement("div", { className: styles.buttonContainer },
                    React.createElement(Button, { className: styles.button, width: '100%', tighterIcons: true, testId: 'rtpm_view_more_details_button', mode: ButtonMode.border, variant: ButtonVariant.light, title: 'View more details', startIcon: React.createElement(AlertEyeIcon, { color: primary }), onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            props.showDecisionSupportWizard();
                        } }, "View more details")))))));
}
function RTPMInformation(props) {
    return (React.createElement("div", { className: styles.rtpmContainer },
        React.createElement("span", { className: styles.rtpmIcon },
            React.createElement(RtpmIcon, { decisionSupportInformation: props.decisionSupportInformation })),
        React.createElement("span", { className: styles.rtpmBody },
            React.createElement("div", { className: styles.rtpmText }, calculateRtpmText(props.decisionSupportInformation)),
            props.decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail.responseUrl && (React.createElement("div", { className: styles.linkContainer },
                React.createElement("a", { href: props.decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail
                        .responseUrl, target: '_blank', rel: 'noreferrer', className: styles.link },
                    "Visit RTPM site",
                    React.createElement("span", { className: styles.linkIcon },
                        React.createElement(ExternalLinkIcon, { size: '20', color: primary, noPadding: true }))))))));
}
function RtpmIcon(props) {
    var defaultIconProps = {
        size: '20',
        noCircularContainer: true,
        noPadding: true
    };
    switch (props.decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail.status) {
        case PrescriptionMonitoringStatus.NotChecked:
        case PrescriptionMonitoringStatus.Acceptable:
        case PrescriptionMonitoringStatus.Passed:
            return React.createElement(DecisionAlertAcceptableIcon, __assign({}, defaultIconProps, { color: green }));
        case PrescriptionMonitoringStatus.Alert:
            return React.createElement(AlertIconRound, __assign({}, defaultIconProps, { color: dangerVariant }));
        case PrescriptionMonitoringStatus.Warning:
            return React.createElement(DecisionAlertWarningIcon, __assign({}, defaultIconProps, { color: warningGlowBorder }));
        case PrescriptionMonitoringStatus.Error:
        default:
            return React.createElement(AlertIconRound, __assign({}, defaultIconProps, { color: body }));
    }
}
function calculateRtpmText(decisionSupportInformation) {
    if (decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail.status ===
        PrescriptionMonitoringStatus.Error ||
        !decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail.responseDescription) {
        return 'Error establishing connection. Please wait while we try to reconnect in the background.';
    }
    return decisionSupportInformation.decisionSupportDetail.prescriptionMonitoringDetail.responseDescription;
}
